// ITER 92 — shared oodel·ˣ FRAMEWORK footer, used at the bottom of the
// public-facing "deep content" pages (snapshot wave detail, crosstab
// detail, tracker detail) to match the branding already used on
// Intelligence Report reads.
export default function OodelXFooter() {
  return (
    <div className="mt-14 px-6 py-8 flex flex-col items-center gap-3" data-testid="oodelx-footer">
      <img
        src="/brand/oodelx-framework.png"
        alt="oodel·ˣ FRAMEWORK"
        className="h-14 md:h-16 object-contain"
        data-testid="oodelx-footer-logo"
      />
    </div>
  );
}
